import jwt_decode from "jwt-decode"

export function decoderJwt (token) {
  const decoded = jwt_decode(token)

  return decoded
}